import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { AuthenticationService } from 'src/app/services/shared/auth.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { DeliveryPlatformService } from 'src/app/services/delivery/delivery-platform.service';
import { PosService } from 'src/app/services/pos/pos.service';
declare var $: any;

@Component({
  selector: 'app-pos-integration-info',
  templateUrl: './pos-integration-info.component.html',
  styleUrls: ['./pos-integration-info.component.scss']
})
export class PosIntegrationInfoComponent implements OnInit {

  fromaddPOS: boolean = true;
  public visiblePages: any = [];
  POS = [];
  posTypes = [];
  posId: any;
  posLoad: boolean = true;
  isPOSTypeSelected: boolean;
  posParameters: any[];
  posFeild: any;
  posSucess: boolean = false;
  isSubmittedPOS = false;
  isPOSFormInvalid = false;
  posFail: boolean = false
  selectedFilterFranchise: any = null; selectedFilterShop: any = null;
  integratedPlatforms = [];
  loaderSpinPos = false;
  franchises: any;
  shops: any = []; shopsFilter: any = []
  qtd: any = [];
  loggedUserRole: any;
  modelId: string = "modalDeletePOS";
  placeholderText: string = "Search";
  selectedPOS: any; selectedPOSName: any;
  isFilterClicked = false;
  pages: any;
  currentPage: any;
  lastPage: any;
  message: any = ""
  searchKeyword: any = '';
  filterAvailability: boolean = false;
  filterSearchAvailability: boolean = true;
  noItemsAvailable: string = "No POS available.";
  tableConfig: Array<object> = [
    { id: 1, header: "POS ID", },
    { id: 2, header: "POS Name", sort: false, classType: "tableHeader" },
    { id: 3, header: "Franchise", classType: "tableHeader" },
    { id: 4, header: "Outlet", classType: "actions no-sort" },
    { id: 5, header: "Date Added", classType: "actions no-sort" },
    { id: 6, header: "Status", classType: "actions no-sort" },
    { id: 7, type: "Policy", classType: "tableHeader_Action actions no-sort" },
  ];
  tableAction: Array<object> = [
    { id: "edit", type: "Edit", image: "../../../../../assets/icons/edit.png" },
    { id: "edit", type: "Delete", image: "../../../../../assets/icons/delete.png" },
  ];

  tableInfo: Array<object> = [
    { id: 1, header: "id", type: "Number", classType: "tableDataFirstCol" },
    { id: 2, header: "name", type: "String", classType: "tableData" },
    { id: 2, header: "franchiseName", type: "String", classType: "tableData", },
    { id: 2, header: "outletName", type: "String", classType: "tableData", },
    { id: 2, header: "created_at", type: "String", classType: "tableData" },
    { id: 3, header: "status", type: "Status", classType: "tableDataStatus", },
    { id: 5, header: "action", },
  ];
  isDataLoadedUser: boolean = false;
  allAccess = false;

  constructor(
    private authService: AuthenticationService,
    private posService: PosService,
    private spinner: NgxSpinnerService,
    private adminService: AdminService
  ) { }

  ngOnInit(): void {
    this.spinner.show();

    this.getCurrentUser();
    this.getAllFranchise();
    this.geOutlets();

    $('.selectpicker').selectpicker('refresh');
    $('#spicker_franchise1').selectpicker('refresh');
    $('#spicker_franchise1').selectpicker('val');


  }



  posForm: FormGroup = new FormGroup({
    franchiseName: new FormControl('',),
    outletName: new FormControl('',),
    franchise_id: new FormControl('', [Validators.required]),
    platform_id: new FormControl('', [Validators.required]),
    shop_id: new FormControl('', [Validators.required]),
    type: new FormControl('', [Validators.required]),
    status: new FormControl('', [Validators.required]),
    parameters: new FormGroup({

    }, [Validators.required]),

  })

  filterForm: FormGroup = new FormGroup({
    franchise: new FormControl(''),
    shop: new FormControl(''),
    franchise_pos: new FormControl(''),
    shop_pos: new FormControl(''),
    shop_auto_aceept: new FormControl(''),
    franchise_auto_aceept: new FormControl(''),
  })

  get pos() { return this.posForm.controls; }

  get pos_api() { return this.posForm.controls.parameters; }

  getCurrentUser() {
    this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;
    if (this.loggedUserRole == 4) {
      this.selectedFilterFranchise = this.authService.getLoggedUser().shops[0].franchise_id;
      this.selectedFilterShop = this.authService.getLoggedUser().shops[0].id;
      this.getPOS();
    } else if (this.loggedUserRole == 3) {
      this.selectedFilterFranchise = this.authService.getLoggedUser().franchises[0].id;
      this.getPOS();
    } else {
      this.getPOS();
    }


    let policies = this.authService.getLoggedUser().policies

    policies.forEach(element => {

      if (element.id == 12) {
        this.allAccess = true;
      }
    });


  }


  getAllFranchise() {
    this.visiblePages = [];
    this.adminService.getAllFranchises()
      .subscribe({
        next: (res) => {
          this.franchises = res.data
          $('#spicker_franchise_pos').selectpicker('refresh');
          $('#spicker_franchise_pos').selectpicker('val');

        },
        error: (error) => {
          console.log(error + "Error");
        }

      })
  }

  geOutlets() {
    this.adminService.getOutlets().subscribe((res) => {
      this.shops = res.data;
      this.shopsFilter = res.data;
    })
  }

  refreshFilters() {

    if (!this.isFilterClicked) {
      this.isFilterClicked = true;
    } else {
      this.isFilterClicked = false;
    }

    $('#spicker_franchise_pos').selectpicker('refresh');
    $('#spicker_franchise_pos').selectpicker('val');

    this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;
    if (this.loggedUserRole > 2) {
      setTimeout(function () {
        $("#spicker_shop_pos").removeAttr("disabled");
        $('#spicker_shop_pos').selectpicker('refresh');
      }, 1);
    }

  }

  async selectFranchise(e) {
    if (this.fromaddPOS) {
      if (e) {
        await this.adminService.getShopsRelatedFranchise(e)
          .subscribe({
            next: (res) => {
              this.shops = res.data
              this.qtd = [];
              if (this.shops.length == 0) {
              }


              setTimeout(function () {

                $("#spicker_shop_pos2").removeAttr("disabled");
                $('#spicker_shop_pos2').selectpicker('refresh');
                $('#spicker_shop_pos2').selectpicker('val', '');

              }, 1);
            },
            error: (error) => console.log(error + "Error")
          })
      }
    }

  }


  async selectFilterFranchise(e) {
    if (e) {
      this.isDataLoadedUser = true;
      await this.adminService.getShopsRelatedFranchise(e)
        .subscribe({
          next: (res) => {
            this.shopsFilter = res.data
            this.qtd = [];


            this.selectedFilterFranchise = e;
            this.selectedFilterShop = null;
            this.getPOS();

            setTimeout(function () {

              $("#spicker_shop_pos").removeAttr("disabled");
              $('#spicker_shop_pos').selectpicker('refresh');
              $('#spicker_shop_pos').selectpicker('val', '');

            }, 1);
            this.isDataLoadedUser = false;
          },
          error: (error) => this.isDataLoadedUser = false
        });

    }

  }

  selectShop(e) {
  }

  selectFilterShop(e) {
    if (e) {
      this.selectedFilterShop = e.id;
      this.getPOS();
      this.isDataLoadedUser = false;
    }
  }

  onStatusChange(value) { }

  /* From here codes related to pos crud */

  getPOSTypes() {
    this.posService.getPOSTypes()
      .subscribe({
        next: (res) => {
          this.posTypes = res.data
          //console.log(res)
        },
        error: (error) => {
          console.log(error + "Error");
        }
      })
  }
  searchItems(event) {
    if (event.target.value == "") {
      this.searchKeyword = ""
    } else {
      this.searchKeyword = event.target.value;
    }
    this.posService.getAllPOS(this.selectedFilterFranchise, this.selectedFilterShop, this.searchKeyword).subscribe(res => {

      this.POS = res.data.poses
      this.isDataLoadedUser = true
      this.getPagesCount(res.data.lastPage)
      this.currentPage = res.data.currentPage
    })

  }
  getPOS() {

    this.visiblePages = [];
    this.getPOSTypes();
    this.posService.getAllPOS(this.selectedFilterFranchise, this.selectedFilterShop, this.searchKeyword)
      .subscribe({
        next: (res) => {
          this.POS = res.data.poses
          let activePosindex = 0;
          this.posLoad = true;
          this.isDataLoadedUser = true
          this.getPagesCount(res.data.lastPage)
          this.currentPage = res.data.currentPage

        },
        error: (error) => {
          console.log(error + "Error")
        }

      })

  }

  getPagesCount(pageCount) {
    this.visiblePages = [];
    let pages = [];
    for (let i = 1; i <= pageCount; i++) {
      pages.push(i);
    }
    this.pages = pages;
    this.pages.slice(0, 5).map(i => {
      this.visiblePages.push(i);
    })
  }

  //pagination

  getMorePages(pageNumber) {
    this.posLoad = false;
    if (pageNumber > 5) {
      this.visiblePages = [];

      this.pages.slice((pageNumber - 5), pageNumber).map(i => {

        this.visiblePages.push(i);
      })
    } else {
      this.visiblePages = [];
      this.pages.slice(0, 5).map(i => {
        this.visiblePages.push(i);
      })
    }


    this.posService.getMorePOS(this.selectedFilterFranchise, this.selectedFilterShop, pageNumber).subscribe(res => {

      this.POS = res.data.poses;
      this.posLoad = true;
      this.isDataLoadedUser = true
      this.currentPage = res.data.currentPage
    });
  }

  onTypeChangePOS(id) {
    //console.log(id)
    if (id == -1 || !id) {
      this.isPOSTypeSelected = false
    } else {

      this.posParameters = this.posTypes;

      let index = this.posParameters.findIndex(x => x.id == id);

      //console.log(index, 'index')

      if (index > -1) {
        this.posFeild = this.posParameters[index].parameters

        let pos_parameters = this.posForm.controls.parameters as FormGroup;
        Object.keys(pos_parameters.controls).forEach(feild => {
          pos_parameters.removeControl(feild)
        })

        for (let i = 0; i < this.posParameters[index].parameters.length; i++) {
          pos_parameters.addControl(this.posParameters[index].parameters[i], new FormControl('', Validators.required));
        }

        this.posForm.patchValue({
          pos_id: id,
          platform_id: id
        })

        if (id > 1) {
          pos_parameters.patchValue({
            EPOS_BASE_URL: this.posParameters[index].parameter_values.EPOS_BASE_URL,
            EPOS_KEY: this.posParameters[index].parameter_values.EPOS_KEY,
            EPOS_SECRET: this.posParameters[index].parameter_values.EPOS_SECRET,
            EPOS_AUTH_TOKEN: this.posParameters[index].parameter_values.EPOS_AUTH_TOKEN,
          })

        } else {
          //console.log(this.posParameters[index], 'Loy', this.posParameters[index].parameter_values.LOYVERSE_ACCESS_TOKEN);
          pos_parameters.patchValue({
            LOYVERSE_VERSION: this.posParameters[index].parameter_values.LOYVERSE_VERSION,
            LOYVERSE_BASE_URL: this.posParameters[index].parameter_values.LOYVERSE_BASE_URL,
            LOYVERSE_ACCESS_TOKEN: this.posParameters[index].parameter_values.LOYVERSE_ACCESS_TOKEN
          })
        }
        this.isPOSTypeSelected = true
      }

    }
  }

  addPOSClick() {
    this.posSucess = false
    this.fromaddPOS = true
    this.posForm.reset()
    this.message = "";

    $("#spicker_franchise_pos2").removeAttr("disabled");
    $('#spicker_franchise_pos2').selectpicker('refresh');
    $('#spicker_franchise_pos2').selectpicker('val', '');

    $('#spicker_shop_pos2').selectpicker('refresh');
    $('#spicker_shop_pos2').selectpicker('val', '');

    //console.log(this.posForm.value);
  }


  addPOS() {
    this.message = "";
    this.isSubmittedPOS = true;
    if (this.posForm.invalid) {
      this.isPOSFormInvalid = true;
      //console.log(this.posForm.invalid);
      this.posForm.setErrors({
        invalidAdd: true
      })
    } else {
      this.loaderSpinPos = true;
      this.posService.addPOS(this.posForm.value)
        .subscribe({
          next: (res) => {
            this.posSucess = true;
            this.loaderSpinPos = false;
            this.isSubmittedPOS = false;
            this.selectedFilterFranchise = null;
            this.selectedFilterShop = null;
            this.isPOSTypeSelected = false;
            this.getPOS();
            this.message = "POS created successfully!"
            $('#posModal').modal('hide');
          },
          error: (error) => {
            this.posSucess = false;
            //this.posFail = true;
            this.loaderSpinPos = false;
            this.message = "POS saved failed! " + error + "!"
          }
        })

    }
  }

  onPOSEditClicked(data) {
    //console.log(data, 'edit data')
    this.fromaddPOS = false;

    if (data.id) {
      this.onTypeChangePOS(data.platform_id);
    }
    this.posId = data.id

    this.posForm.patchValue(data)

    this.posForm.patchValue({
      //franchise: 1,
      type: data.platform_id,
      parameters: data.parameter_values
    })

    $('#posModal').modal('show');

  }

  //delete POS Model
  open_deleteItemModal(data) {
    //console.log(data, 'selected')

    this.selectedPOS = data;
    this.selectedPOSName = data.name
    $('#modalDeletePOS').modal('show');
  }
  //delete POS API 
  deleteOutlet() {
    this.loaderSpinPos = true;
    this.posService.deletePOS(this.selectedPOS.id)
      .subscribe({
        next: (res) => {
          this.getPOS();
          this.loaderSpinPos = false;
          $('#modalDeletePOS').modal('hide');
        },
        error: (error) => {
          console.log(error + "Error")
          this.loaderSpinPos = false;
        }
      })
  }

  editPOS() {
    this.message = "";
    this.isSubmittedPOS = true;
    if (this.posForm.invalid) {
      this.isPOSFormInvalid = true;
      this.posForm.setErrors({
        invalidAdd: true
      })
    } else {
      this.loaderSpinPos = true;
      this.posService.updatePOS(this.posId, this.posForm.value)
        .subscribe({
          next: (res) => {
            this.posSucess = true;
            this.loaderSpinPos = false;
            this.isSubmittedPOS = false;
            this.message = "POS updated successfully!"
            this.getPOS();
          },
          error: (error) => {
            this.posSucess = false;
            this.posFail = true;
            this.loaderSpinPos = false;
            this.message = "POS Update Failed! " + error + "!";
          }
        })
    }
  }



  onCancelPOSModal() {
    this.isSubmittedPOS = false;
    this.isPOSTypeSelected = false;
    this.isPOSFormInvalid = false;
    this.posSucess = false;
    this.message = ""
    this.posForm.reset()
    $('#posModal').modal('hide');
  }

  modalPOSCloseSucess() {
    this.posSucess = false
  }

  modalPOSCloseFail() {
    this.posFail = false
  }

}
